import { TextField } from "@mui/material";
import { useContext } from "react";

import Context from "../context";

// ----------------------------------------------------------------------

export const FilterName = () => {
	const { actions, state } = useContext(Context);

	const handleOnChange = ({ target }: any) => {
		actions.onChangeFilterName(target.value);
	};

	return (
		<TextField
			value={state.filterName}
			size='small'
			placeholder='Filtrar por nombre'
			sx={{ width: 330 }}
			onChange={handleOnChange}
		/>
	);
};

export default FilterName;
